import type { ChangeEvent, ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { paths } from '@/shared/config';
import { SelectField } from '@/shared/ui/field';

import styles from './Sidebar.module.scss';

export interface OrganizationOption {
  id: number;
  name: string;
}

interface OrganizationSwitcherProps {
  organizations: ReadonlyArray<OrganizationOption>;
  organizationId: number | null;
  onNavigate: () => void;
}

export function OrganizationSwitcher({
  organizations,
  organizationId,
  onNavigate,
}: OrganizationSwitcherProps): ReactElement {
  const navigate = useNavigate();
  const changeOrganization = (event: ChangeEvent<HTMLSelectElement>): void => {
    onNavigate();
    void navigate(paths.organization(Number(event.target.value)));
  };
  return (
    <div className={styles.switcher}>
      <SelectField
        label="Организация"
        value={organizationId ?? ''}
        placeholder={organizationId === null ? 'Выберите организацию' : undefined}
        options={organizations.map(({ id, name }) => ({ value: String(id), label: name }))}
        onChange={changeOrganization}
      />
    </div>
  );
}
